import { API_ROUTES, HTTP_METHODS, PAGE_SIZE } from '@Utils/constants';
import { sendCall } from '@Utils/request.utils';

const { LOCATION } = API_ROUTES;

class LocationService {
  createLocation = (params: unknown) => sendCall(LOCATION.POST, { data: params, method: HTTP_METHODS.POST });

  updateLocation = (id: string | undefined, params: unknown) =>
    sendCall(`${LOCATION.PUT}/${id}`, { data: params, method: HTTP_METHODS.PUT });

  getLocations = (page: number | null, pagination: boolean) =>
    sendCall(`${LOCATION.GET}?page=${page}&limit=${PAGE_SIZE}&pagination=${pagination}`, {
      method: HTTP_METHODS.GET,
    });

  disableLocation = (id: string | undefined) => sendCall(`${LOCATION.DISABLE}/${id}`, { method: HTTP_METHODS.POST });

  searchLocation = (params: unknown, page: number) =>
    sendCall(`${LOCATION.SEARCH_POST}?page=${page}&limit=${PAGE_SIZE}`, {
      data: params,
      method: HTTP_METHODS.POST,
    });
}

export default new LocationService();
